import { useRef, useState, useEffect } from 'react'

import {
  ValuePicker,
  type Filter,
} from '@tribeplatform/react-components/Filters'
import { T } from '@tribeplatform/react-components/i18n'
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl'

interface Props {
  processedInlineFilter: Filter
  onChange: (options: string[]) => void
}
export const NarrowDownValuePicker = ({
  processedInlineFilter,
  onChange,
}: Props) => {
  const [draftFilter, setDraftFilter] = useState<Filter>({
    ...processedInlineFilter,
    value: processedInlineFilter?.extraProps?.narrowedDownOptions,
    extraProps: {
      ...processedInlineFilter?.extraProps,
      narrowedDownOptions: [],
    },
  })
  const firstRender = useRef(true)

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false
    }
  }, [])

  const handleChange = (value: Filter['value']) => {
    setDraftFilter(prev => {
      const newFilter: Filter = {
        ...prev,
        value,
      }
      return newFilter
    })

    if (!Array.isArray(value) || value.length === 0) {
      return
    }

    onChange(value)
  }

  return (
    <div>
      <ValuePicker filter={draftFilter} onChange={handleChange} />
      {!firstRender.current &&
        Array.isArray(draftFilter.value) &&
        draftFilter.value.length === 0 && (
          <FormControl.HelperText status="error">
            <T
              defaultMessage="At least one option should be provided."
              id="InlineFilterSettings.Validation.OptionsRequired"
            />
          </FormControl.HelperText>
        )}
    </div>
  )
}
